import type { Tab } from './index';

const LEVELS = ['all','beginner','intermediate','advanced','strategies','greeks'] as const;

export class OptionsEducationTab implements Tab {
  readonly id = 'options';

  init(): void {
    document.querySelectorAll<HTMLElement>('[data-ol-level]').forEach(btn =>
      btn.addEventListener('click', () => this.showLevel(btn.dataset.olLevel ?? 'all')),
    );
  }

  render(): void { /* static content — nothing to load */ }

  private showLevel(level: string): void {
    LEVELS.forEach(l => {
      const btn = document.getElementById(`ol-${l}`);
      const active = l === level;
      if (btn) {
        btn.style.background  = active ? 'rgba(0,212,255,0.15)' : 'transparent';
        btn.style.borderColor = active ? 'rgba(0,212,255,0.4)'  : 'var(--border)';
        btn.style.color       = active ? 'var(--accent)'        : 'var(--text3)';
      }
    });
    document.querySelectorAll<HTMLElement>('.options-section').forEach(sec => {
      sec.style.display = level === 'all' || sec.dataset.level === level ? 'block' : 'none';
    });
  }
}
